import Select2 from '../../../src/js/shared/select2';

'use strict';
const $ = jQuery.noConflict();
$(function() {
	const contactBlock = {
		redirectUrl: '/contact-thank-you/',

		init: function() {
			this.cacheDOM();
			if (!this.$blocks.length) return;
			this.initSelects();
			this.bindEvents();
		},

		cacheDOM: function() {
			this.$blocks = $('.js-contact-block');
		},

		initSelects: function() {
			$('.js-contact-block .contact-block__select').each((i, el) => {
				const $el = $(el);
				Select2.initializeSelect2($el, {
					width: '100%',
					theme: 'default',
					dropdownCssClass: 'contact-block__select-dropdown',
					dropdownParent: $el.closest('.contact-block__field'),
				});
			});
		},

		bindEvents: function() {
			this.$blocks.each((i, block) => {
				const wrapper = block.querySelector('.wpcf7');
				const form = block.querySelector('.wpcf7 form');
				if (!wrapper || !form) return;
				const redirectUrl = block.dataset.redirectUrl || this.redirectUrl;
				wrapper.addEventListener('wpcf7mailsent', () => this.onMailSent(redirectUrl), false);
				this.initSubmitValidation(form);
			});
		},

		initSubmitValidation: function(form) {
			const submitBtn = form.querySelector('.wpcf7-submit');
			if (!submitBtn) return;

			const toggleSubmit = () => {
				submitBtn.disabled = !this.isFormValid(form);
			};

			form.addEventListener('input', toggleSubmit);
			form.addEventListener('change', toggleSubmit);
			toggleSubmit();
		},

		isFormValid: function(form) {
			let valid = form.checkValidity();

			form.querySelectorAll('.wpcf7-validates-as-required').forEach((field) => {
				if (field.type === 'checkbox' || field.type === 'radio') {
					if (!field.checked) valid = false;
				} else if (!field.value.trim()) {
					valid = false;
				}
			});

			return valid;
		},

		onMailSent: function(redirectUrl) {
			window.location.href = redirectUrl;
		},
	};

	contactBlock.init();
});
